import {
  Button,
  Col,
  Divider,
  Drawer,
  Form,
  Menu,
  message,
  Popover,
  Row,
  Typography,
} from "antd";
import { useForm } from "../../utils/hooks/useForm";
import { ReactComponent as MenuFoldIcon } from "../../assets/MenuUnfoldIcon.svg";
import FloatInput from "../../components/FloatInput/floatInput";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import { useAuth } from "../../utils/hooks/useAuth";
import "./verifyOTP.modules.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ChevronLeft } from "../../assets/chevron-left.svg";
import { useCountDown } from "../../utils/hooks/useCountDown";
import { useState } from "react";
import { allowNumOnly } from "../../utils/methods/form-validations";
import { useSideBarMenu } from "../../utils/content/sidebar-menus";
import { DownOutlined } from "@ant-design/icons";
import HipaaSealImage from "../../components/HipaaSeal/HipaaSeal";

const VerifyOTPNetwork = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { form } = useForm();
  const { NAVBAR_INFO_MOBILE, POPUP_CONTENT, open, setOpen } = useSideBarMenu();
  const {
    handleVerifyNetworkOTP,
    handleResendNetworkOtp,
    isLoading,
    isApiLoading,
  } = useAuth(form);
  const { count, resetCount } = useCountDown(60);
  const [isResetCode, setIsResetCode] = useState(false);

  const handleResetCode = () => {
    resetCount();
    setIsResetCode(true);
    form?.submit();
  };

  const onFinish = async (values: { otp: string }) => {
    try {
      if (isResetCode) {
        await handleResendNetworkOtp(
          location.state.phoneNumber || "",
          location.state.npiNumber || "",
          resetCount
        );
        return;
      }
      await handleVerifyNetworkOTP({
        npi_number: location.state.npiNumber,
        phoneNumber: location.state.phoneNumber,
        otp: values.otp.toString(),
      });
    } catch (error) {
      message.error(`${error}`);
    } finally {
      setIsResetCode(false);
    }
  };

  return (
    <div className="bg-custom-radial flex flex-col w-full network-otp justify-between">
      <div className="flex flex-col justify-center items-center w-full max-w-[1440px] overflow-y-hidden mobile-lg:h-full mx-auto lg:gap-x-40">
        <div className="flex justify-center items-center w-full px-6 py-4 max-w-[1440px] lg:gap-x-40">
          <div className="flex justify-between gap-x-8 items-center w-full lg:w-auto">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal lg:mr-auto"
              />
            </Link>
            <MenuFoldIcon
              onClick={() => setOpen((prevState) => !prevState)}
              className="lg:hidden text-[#565656]"
            />
            <Popover
              placement="bottom"
              title={""}
              content={POPUP_CONTENT}
              className="nav_popover"
            >
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="hidden link-block lg:flex justify-center items-center"
                onClick={(e) => e.preventDefault()}
              >
                What We Offer <DownOutlined className="chevron-down" />
              </Link>
            </Popover>
            <Link
              to={"https://www.docupdate.io/manage-preferences"}
              className="hidden link-block lg:flex justify-center items-center"
            >
              Manage Preferences
            </Link>
          </div>
          <div className="hidden lg:flex justify-center gap-x-4 items-center">
            <Link
              to={"/signup-new"}
              className="link-button-white flex justify-center items-center"
            >
              Sign Up
            </Link>
            <Link
              to={"https://docupdate.onelink.me/j4xR/desktop"}
              className="link-button flex justify-center items-center"
            >
              Get the App
            </Link>
          </div>
        </div>

        <div className="my-2 flex flex-col justify-center items-center w-full px-6 py-4 max-w-[1440px] mx-auto h-full">
          <Form
            form={form}
            name="signup"
            onFinish={onFinish}
            className="my-6 pt-2 flex flex-col bg-[white] w-full max-w-[470px] justify-center items-center rounded-xl mobile-m:rounded-3xl px-2 mobile-m:px-4"
          >
            <div className="flex flex-col justify-center items-center max-w-[380px] w-full">
              <div className="w-full flex justify-between items-center mt-4 lg:mt-8">
                <Button
                  className="bg-transparent border-solid border-[#d5d7da] text-[#A8BDC1] rounded-[8px] p-4 hover:bg-[#e8f3ff] hover:text-[#7e5aeb]"
                  icon={<ChevronLeft />}
                  onClick={() => navigate("/signup-new")}
                />
                <Typography.Text className="w-full mr-8 font-playfair text-center text-3xl text-[#0F0F1C] font-semibold">
                  {"Verify OTP"}
                </Typography.Text>
              </div>
              <Typography.Text className="m-4 mb-2 font-inter text-center leading-4 text-[12px] text-normal text-[#5d6769] mobile-m:text-sm mobile-m:mb-4">
                Please verify your phone number with OTP below.
              </Typography.Text>

              <Row
                gutter={[12, 12]}
                className={`w-full justify-center items-center`}
              >
                <Col span={24}>
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        ...(!isResetCode && {
                          required: true,
                          message: "Please enter the OTP.",
                        }),
                      },
                      {
                        pattern: /^\d{6}$/,
                        message: "OTP must be a 6-digit number.",
                      },
                    ]}
                  >
                    <FloatInput
                      type="text"
                      placeholder="XXXXXX"
                      maxLength={6}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        allowNumOnly(e, form, "otp")
                      }
                      controls={false}
                      onPressEnter={() => form.submit()}
                      label="OTP Number"
                      required={true}
                    />
                  </Form.Item>
                </Col>
                <div className="flex flex-col justify-center items-center mb-8 gap-y-4 w-full">
                  {!!count ? (
                    <Typography.Text className="font-urbanist text-[#7e5ae2] font-semibold text-lg w-full text-center leading-[28px] tracking-[0px]">
                      Resend OTP in {count}
                    </Typography.Text>
                  ) : (
                    <Button
                      className="font-urbanist text-[#7e5ae2] font-semibold text-lg text-center"
                      type="link"
                      block
                      onClick={handleResetCode}
                    >
                      Resend OTP
                    </Button>
                  )}
                  <Button
                    type="primary"
                    htmlType={"submit"}
                    loading={isLoading || isApiLoading}
                    className={`font-urbanist font-semibold bg-[#7e5ae2] w-[96%] mobile-m:w-full mobile-m:max-w-[370px] rounded-full py-[30px] mobile-m:px-[0px] border-none text-base`}
                  >
                    Verify Phone Number
                  </Button>
                </div>
              </Row>
            </div>
          </Form>
        </div>
      </div>
      <div className="mt-6 bg-[#f2fdff] flex flex-col w-full justify-center items-center">
        <div className="min-h-400px px-6 py-4 flex w-full max-w-[1080px] justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-y-4 md:gap-y-6">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal"
              />
            </Link>
            <div className="flex flex-col items-start gap-y-4 md:flex-row md:gap-x-8">
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="link-block-light flex justify-center items-center"
              >
                Manage Preferences
              </Link>
              <Link
                to={"https://www.docupdate.io/#faq"}
                className="link-block-light flex justify-center items-center"
              >
                Help
              </Link>
              <Link
                to={"https://www.docupdate.io/privacy-policy/"}
                className="link-block-light flex justify-center items-center"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
          <HipaaSealImage />
        </div>
        <Divider className="w-full max-w-screen-2xl" />
        <div className="flex flex-col md:flex-row justify-between items-center w-full p-4 max-w-[1080px] gap-y-3">
          <div className="flex justify-center items-center">
            <Typography.Text className="footer-text-color">
              Copyright © 2025 DocUpdate | All Rights Reserved.
            </Typography.Text>
          </div>
          <div className="flex justify-center gap-x-8 items-center">
            <Link
              to={"https://www.docupdate.io/terms-of-service/"}
              className="link-block-lighter flex justify-center items-center"
            >
              Terms of Service
            </Link>
            <Link
              to={"https://www.docupdate.io/do-not-call-policy/"}
              className="link-block-lighter flex justify-center items-center"
            >
              DNC Policy
            </Link>
            <Link
              to={
                "https://www.docupdate.io/hipaa-business-associate-agreement/"
              }
              className="link-block-lighter flex justify-center items-center"
            >
              HIPAA Terms
            </Link>
            <Link
              to={"https://www.docupdate.io/ccpa-notice/"}
              className="link-block-lighter flex justify-center items-center"
            >
              CCPA Notice
            </Link>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        className={`navbar_drawer flex justify-center p-[0.85rem_1.5rem] w-full`}
      >
        <div className="flex flex-col gap-y-10 w-full h-full">
          <Typography.Text className="font-playfair text-3xl text-center">
            What We Offer
          </Typography.Text>
          <Menu
            mode="inline"
            className="w-full h-full border-none flex flex-col gap-y-4 max-h-[360px]"
            items={NAVBAR_INFO_MOBILE}
            defaultSelectedKeys={["1"]}
          />
          <Link
            to={"/signup-new"}
            className="link-button-white flex justify-center items-center"
          >
            Sign Up
          </Link>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="link-button flex justify-center items-center"
          >
            Get the App
          </Link>
        </div>
      </Drawer>
    </div>
  );
};

export default VerifyOTPNetwork;
